<!--
 * @Author: your name
 * @Date: 2021-08-18 18:22:24
 * @LastEditTime: 2021-08-23 18:12:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\views\errors\index.vue
-->
<template>
  <div class="error">
    <h1>404</h1>
    <a href="/">返回首页</a>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.error {
  width: 100%;
  margin-top: 20vh;
  text-align: center;
  > h1 {
    font-size: 100px;
    margin-bottom: 20px;
  }
}
</style>
